var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"lp-avatar",style:(_vm.style)},[(_vm.photo)?_c('img',{attrs:{"src":_vm.photo,"alt":_vm.name || '',"loading":"lazy"}}):[_vm._v(_vm._s(_vm.initials))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }